import React, { FC, useRef, useState } from 'react';
import s from './mightLike.module.scss';
import { useTranslation } from '@hooks/useTranslation';
import { useGetPublicToysInfinity } from '@hooks/TRPC_Hooks/useGetToys';
import { collectionMeta } from '@specs/specs';
import { InfinityList } from '@components/InfinityList/InfinityList';
import { ToyCard } from '@components/Cards/ToyCard/ToyCard';
import { Button } from '@components/UIKit/Button/Button';
interface Props {
  collectionId: collectionMeta['id'];
}
const limit = 5;
export const MightLike: FC<Props> = ({
  collectionId
}) => {
  const {
    translate: tr
  } = useTranslation();
  const [showMore, setShowMore] = useState(false);
  const enabledRef = useRef(false);
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status
  } = useGetPublicToysInfinity({
    limit,
    collection: collectionId
  }, {
    enabled: enabledRef.current
  });
  return <div className={s.mightLike} data-sentry-component="MightLike" data-sentry-source-file="MightLike.tsx">
            <div className={s.mightLike__title}>
                {tr({
        id: 'toy.page.you.might.like'
      })}
            </div>
            <div className={s.mightLike__grid}>
                <InfinityList fetchNextPage={fetchNextPage} data={data} hasNextPage={hasNextPage && showMore} isFetchingNextPage={isFetchingNextPage} status={status} enabledRef={enabledRef} listClassName={'_toysGrid'} data-sentry-element="InfinityList" data-sentry-source-file="MightLike.tsx">
                    {item => <ToyCard key={item.id} {...item} />}
                </InfinityList>
            </div>
            {!showMore && hasNextPage && <Button className={s.mightLike__button} color={'Black'} size={'medium'} id='might_like_button' onClick={async () => {
      setShowMore(true);
      await fetchNextPage();
    }}>
                    {tr({
        id: 'btn.see.more'
      })}
                </Button>}
        </div>;
};